import {Card, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	padding: 24px;
	min-width: 394px;
	max-width: calc(50% - 8px);

	${({theme}) => theme.breakpoints.down('sm')} {
		min-width: 100%;
		max-width: 100%;
	}
`;
